import { BaseComponent } from '../../base-component';
import { trackEvent, trackView } from '@otto-ec/nexus-registry/pdp/tracking';
import { createLightbox } from '../../_common/client/nexus-interfaces/lightbox';

export class MeasurementSectionComponent extends BaseComponent {
    public rootSelector = '.js_pdp_measurement-section';

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        await this.initSketchLightboxes();

        const [expanderElement] = this.getChildElements<HTMLOcExpanderV1Element>('.js_pdp_measurement-section__expander');
        if (!expanderElement) {
            trackView({ product_Measurement: ['unfolded'] });
            return;
        }

        expanderElement.addEventListener('oc-open', () => this.handleExpanderOpened());
        expanderElement.addEventListener('oc-close', () => this.handleExpanderClosed());

        this.performViewTracking(expanderElement);
    }

    private async initSketchLightboxes(): Promise<void> {
        const galleries = ['.js_pdp_measurement-section__sketches--mobile', '.js_pdp_measurement-section__sketches--desktop'];
        await Promise.all(
            galleries
                .filter(gallery => this.getRootElement().querySelector(gallery))
                .map(gallery =>
                    createLightbox({
                        gallery: this.getRootElement().querySelector<HTMLElement>(gallery)!,
                        children: '.js_pdp_measurement-section__sketch-item',
                        thumbSelector: 'img',
                    })
                )
        );
    }

    private performViewTracking(expanderElement: HTMLOcExpanderV1Element): void {
        trackView({
            product_Measurement: [expanderElement.isCutOff ? 'folded' : 'unfolded'],
        });
    }

    private handleExpanderOpened(): void {
        trackEvent({
            product_Measurement: ['show more'],
        });
    }

    private handleExpanderClosed(): void {
        trackEvent({
            product_Measurement: ['show less'],
        });

        this.getRootElement().scrollIntoView();
    }
}
